import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GamesGroupListComponent } from './games-group-list/games-group-list.component';
import { GamesGroupItemComponent } from './games-group-item/games-group-item.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { GamesQuestionItemComponent } from './games-question-item/games-question-item.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GameTriviaQuestionListComponent } from './game-trivia-question-list/game-trivia-question-list.component';
import { CircleProgressBarModule } from '@fgb/portal-component-library/src/lib/shared/circle-progress-bar';
import { LinearProgressBarModule } from '@fgb/portal-component-library/src/lib/shared/linear-progress-bar';
import { AnswerTypeTextComponent } from './game-answer-types/answer-type-text/answer-type-text.component';
import { AnswerTypeTextAndImageComponent } from './game-answer-types/answer-type-text-and-image/answer-type-text-and-image.component';
import { GameResultComponent } from './game-result/game-result.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { GamesListModalComponent } from './games-list-modal/games-list-modal.component';
import { AnswerMultiCounterComponent } from './game-answer-types/answer-multi-counter/answer-multi-counter.component';
import { AnswerTypeCounterComponent } from './game-answer-types/answer-type-counter/answer-type-counter.component';
import { AnswerTypeDropdownComponent } from './game-answer-types/answer-type-dropdown/answer-type-dropdown.component';
import { GamePredictorQuestionListComponent } from './game-predictor-question-list/game-predictor-question-list.component';
import { GamePredictorResultComponent } from './game-predictor-result/game-predictor-result.component';
import { GamePredictorThanksForPlayingModalComponent } from './game-predictor-thanks-for-playing-modal/game-predictor-thanks-for-playing-modal.component';
import { GamePredictorUnsavedWarningModalComponent } from './game-predictor-unsaved-warning-modal/game-predictor-unsaved-warning-modal.component';
import { CountdownV2Component } from '@fgb/portal-component-library/src/lib/shared/countdown-v2';
import { CounterModule } from '@fgb/portal-component-library/src/lib/shared/counter';
import { FormsModule } from '@angular/forms';
import { GamePollsQuestionListComponent } from './game-polls-question-list/game-polls-question-list.component';
import { GamePollsResultComponent } from './game-polls-result/game-polls-result.component';
import { AnswerCounterPredictorResultComponent } from './game-predictor-result/answer-counter-predictor-result/answer-counter-predictor-result.component';
import { AnswerTextPredictorResultComponent } from './game-predictor-result/answer-text-predictor-result/answer-text-predictor-result.component';
import { GameResultPrizeComponent } from './game-result/game-result-prize/game-result-prize.component';
import { RewardStatusComponent } from '@fgb/portal-component-library/src/lib/loyalty/reward-status';
import { FeaturedPollsComponent } from './featured-polls/featured-polls.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { SocialShareModalModule } from '@fgb/portal-component-library/src/lib/shared/social-share-modal';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AnswerTypeVideoCarouselComponent } from './game-answer-types/answer-type-video-carousel/answer-type-video-carousel.component';
import { VideoPlayerComponent } from '@fgb/portal-component-library/src/lib/shared/video-player';

@NgModule({
  declarations: [
    GamesGroupListComponent,
    GamesGroupItemComponent,
    GamesListModalComponent,
    GamesQuestionItemComponent,
    GameTriviaQuestionListComponent,
    GameResultComponent,
    AnswerTypeTextComponent,
    AnswerTypeTextAndImageComponent,
    AnswerMultiCounterComponent,
    AnswerTypeCounterComponent,
    AnswerTypeDropdownComponent,
    GamePredictorQuestionListComponent,
    GamePredictorResultComponent,
    GamePredictorThanksForPlayingModalComponent,
    GamePredictorUnsavedWarningModalComponent,
    GamePollsQuestionListComponent,
    GamePollsResultComponent,
    AnswerCounterPredictorResultComponent,
    AnswerTextPredictorResultComponent,
    GameResultPrizeComponent,
    FeaturedPollsComponent,
    AnswerTypeVideoCarouselComponent,
  ],

  imports: [
    CommonModule,
    FGBSharedModule,
    NgbModule,
    CircleProgressBarModule,
    LinearProgressBarModule,
    PipesModule,
    CountdownV2Component,
    RewardStatusComponent,
    CounterModule,
    FormsModule,
    CarouselModule,
    RouterModule,
    DirectivesModule,
    SocialShareModalModule,
    InlineSVGModule.forRoot(),
    VideoPlayerComponent,
  ],
  exports: [
    GamesGroupListComponent,
    GamePollsQuestionListComponent,
    FeaturedPollsComponent,
    GamesQuestionItemComponent,
    GameTriviaQuestionListComponent,
    GamePredictorQuestionListComponent,
    GamesGroupItemComponent,
    GamesListModalComponent,
  ],
})
export class GamesModule {}
